// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const deleteEntryPathParamsSchema = z.object({
  id: z.number().int().describe("Entry ID"),
});

export const deleteEntryHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Entry deleted
 */
export const deleteEntry200Schema = z.object({});

/**
 * @description Unauthorized
 */
export const deleteEntry401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Entry not found
 */
export const deleteEntry404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const deleteEntryMutationResponseSchema = z.lazy(() => deleteEntry200Schema);
